import { map, omit, head, filter, pipe } from 'ramda';

import * as types from '../constants';

// transform response from API
// from barber-root structure { id: 123, ... , users: [{ id: 123, ... }] }
// tor user-root structure { id: 123, ... , barbers: [{ id: 123, ... }] }
// so it matches users table
const swapBarbersAndUsers = map(barber => ({
  ...head(barber.users),
  barbers: [omit(['users'], barber)],
}));

const filterOutEmptyUsers = filter(barber => !!barber.users.length);
const transformBarbers = pipe(filterOutEmptyUsers, swapBarbersAndUsers);

const barberUsersByShop = (state = {}, action) => {
  const affected = {};
  switch (action.type) {
    case types.FETCH_SHOP_BARBERS_SUCCESS:
      return { ...state, [action.payload.shopId]: transformBarbers(action.payload.barbers) };
    case types.DELETE_USER_SUCCESS:
      // eslint-disable-next-line no-restricted-syntax
      for (const shopId in state) {
        if (Object.prototype.hasOwnProperty.call(state, shopId)) {
          affected[shopId] = state[shopId].filter(user => user.id !== action.payload);
        }
      }

      return {
        ...state,
        ...affected,
      };
    case types.CLEAR_BARBERS_BY_SHOP:
      return {};
    default:
      return state;
  }
};

export default barberUsersByShop;
